import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<'loading', MessageDescriptor> = defineMessages({
	loading: {
		id: 'native-embeds-avpviz-experience.chart-loading.loading',
		defaultMessage: 'Loading chart',
		description: 'Accessible label for the placeholder shown while an embedded chart loads.',
	},
});

export default messages;
